import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { encryptPassword } from "../../../../utils/functions";
import { getSpk } from "../../../../../Redux/reducer/env";
import * as instanceActions from "../../../../../Redux/api";
import StepControl from "../../register/steps/stepControl";
import Modal from "../../../../utils/customModal";
import { errorContainer, loadingHtml } from "../../../../utils/functions";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";
import LockIcon from "../../../../../../static/images/secret-word.svg";

export class ResetStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      randomQuestion: {},
      user: {
        answer: "",
      },
      errors: {
        answer: "",
      },
      modal: {
        show: false,
        content: null,
        onClose: undefined,
      },
    };
  }

  componentDidMount() {
    const { modal } = this.state;
    const { instance: { instanceAction } } = this.props;
    modal.show = true;
    modal.content = loadingHtml();
    this.setState({ modal });

    return instanceAction(`/security-question/random`, "post", {
      codUser: encryptPassword(this.props.user.codUser, this.props.spk),
    })
      .then((response) => {
        modal.show = false;
        modal.content = null;
        this.setState({ randomQuestion: response.data.data, modal });
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.modalMessage = {
            title: notification.message,
            message: notification.description,
          };
        }
        modal.type = "error";
        this.setState({ modal });
      });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.content = null;
    modal.onClose = undefined;
    this.setState({ modal });
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        key={`clear-${element}`}
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    this.setState({ user });
  }

  handlerChange(event) {
    // Limpiamos los errores
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  submitForm(e) {
    e.preventDefault();
    const { user, randomQuestion, errors } = this.state;

    // validamos campos vacios
    if (user.answer != "") {
      errors.answer = "";
      this.setState({ errors });
      //si todo va bien vamos al paso 2
      const { user, modal } = this.state;
      const { instance: { instanceAction } } = this.props;

      modal.show = true;
      modal.content = loadingHtml();
      this.setState({ modal });
      return instanceAction(
        `/password-recovery/check-security-question`,
        "post",
        {
          codUser: encryptPassword(this.props.user.codUser, this.props.spk),
          idQuestion: randomQuestion.id,
          securityQuestionAnswer: encryptPassword(
            user.answer,
            this.props.spk
          ),
        }
      )
        .then(() => {
          this.props.submitStep(true);
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            modal.content = errorContainer(
              notification.message,
              notification.description,
              { continueBtn: { action: this.closeModal, text: 'Aceptar' } }
            );
          }
          modal.onClose = () => this.closeModal();
          this.setState({ modal });
        });
    } else {
      if (user.answer == "") {
        errors.answer = "Debe completar este campo";
      }
      this.setState({ errors });
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal, randomQuestion } = this.state;
    return (
      <div id="step-3">
        <div className="user-credentials">
          <h1>Pregunta de seguridad</h1>
          <h1>{randomQuestion.description}</h1>
          <div className="login-form fix-question">
            <form action="post" className="login" onSubmit={(e) => this.submitForm(e)}>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="answer"
                  name="answer"
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  placeholder={`Responda la pregunta de seguridad`}
                  autoComplete="off"
                  value={this.state.user.answer}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("answer")}
                {this.displayError("answer")}
              </div>
              <StepControl
                currentStep={3}
                submitStep={(e) => this.submitForm(e)}
                goBack={() => this.props.submitStep(false)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </div>
    );
  }
}

ResetStep3.propTypes = {
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    registerInfo: state.sessionInfoReducer.registerInfo,
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(ResetStep3);
